<template>
  <div>
    <div>
      <div v-if="listes_service.length > 0" class="cardM">
        <router-link
          :to="{
            name: 'mise_jour_vidange_okba',
            params: { id: listes_service[0].id },
          }"
        >
          <CButton
            v-if="listes_service[0].man == 0"
            style="
              margin-bottom: 7px;
              border-radius: 15px 18px;
              margin-top: -18px;
              margin-left: -8px;
            "
            color="info"
            class="mr-1 cl"
          >
            Nouveau
          </CButton>
        </router-link>

        <router-link
          :to="{
            name: 'mise_a_jour_vidange_man',
            params: { id: listes_service[0].id },
          }"
        >
          <CButton
            v-if="listes_service[0].man == 1"
            style="
              margin-bottom: 7px;
              border-radius: 15px 18px;
              margin-top: -18px;
              margin-left: -8px;
            "
            color="info"
            class="mr-1 cl"
          >
            Nouveau
          </CButton>
        </router-link>

        <router-link
          :to="{
            name: 'detaille_service',
            params: { id: this.$route.params.id },
          }"
        >
          <CButton
            style="
              margin-bottom: 7px;
              border-radius: 15px 18px;
              margin-top: -18px;
              margin-left: 11px;
            "
            color="warning"
            class="mr-1 cl"
          >
            Service
          </CButton>
        </router-link>
        <router-link
          :to="{
            name: 'detaille_facture_vidange',
            params: { id: this.$route.params.id },
          }"
        >
          <CButton
            style="
              margin-bottom: 7px;
              border-radius: 15px 18px;
              margin-top: -18px;
              margin-left: 14px;
            "
            color="success"
            class="mr-1 cl"
          >
            Facture
          </CButton>
        </router-link>

        <!--  -->
        <CCard
          class="cardLDepDashbord"
          style="
            border: solid 1px #7a7979;
            width: 100% !important;
            margin-left: 0px !important;
          "
          accent-color="info"
        >
          <CCardBody>
            <CRow>
              <div class="col-5">
                <label>Matricule</label>
                <input
                  class="form-control personaliseMat"
                  disabled
                  v-model="listes_service[0].matr"
                  type="text"
                />
              </div>

              <div class="col-5">
                <label>Chauffeur</label>
                <input
                  class="form-control personaliseMat"
                  disabled
                  v-model="listes_service[0].nom_chouffeur"
                />
              </div>
              <div class="col-2">
                <img
                  @click="delete_vidange(listes_service[0].id)"
                  style="margin-left: 4px"
                  src="sup.png"
                />
              </div>
            </CRow>
          </CCardBody>
        </CCard>

        <CCard
          v-for="(kilo, k) in listes_service[0].Kilometrage"
          :key="k"
          class="cardLDepDashbord"
          style="
            border: solid 1px #7a7979;
          "
          accent-color="info"
        >
          <CCardBody>
            <CRow>
              <div class="col-4">
                <!--  v-if="listes_service[0].man == 1" -->
                <a
                  :href="
                    'https://apil.auto-turki.com/api/dynamic_pdf/pdf_vidange_man/' +
                    kilo.facturatin_id
                  "
                  target="_blank"
                  style="background-color: transparent !important"
                >
                  <img src="imp_vid.png" />
                </a>
              </div>

              <div class="col-6">
                <div v-if="kilo.paye == 'Non payé'" class="non_paye_f">
                  Facture Non payé
                </div>

                <div v-if="kilo.paye == 'Payé'" class="paye_f">
                  Facture Payé
                </div>

                <div v-if="kilo.paye == 'En attente'" class="en_attente_f">
                  Facture En attente
                </div>
              </div>

              <div class="col-2">
                <img @click="deleteKilometrageService(kilo.id)" src="sup.png" />

                <!--  <CButton
                  @click="deleteKilometrageService(kilo.id)"
                  color="danger"
                  class="mr-1 cl"
                >
                  delete
                </CButton> -->
              </div>
            </CRow>
            <hr />
            <CRow>
              <div class="col">
                <label>Date</label>
                <input
                  class="form-control personalise"
                  disabled
                  v-model="kilo.date"
                  type="text"
                />
              </div>

              <div class="col">
                <label>Kilometrage</label>
                <input
                  class="form-control personalise"
                  disabled
                  v-model="kilo.nb_klm"
                />
              </div>
            </CRow>
            <hr />

            <CRow v-for="(programme, index) in kilo.Traitement" :key="index">
              <div class="col-10">
                <span style="font-size: 15px">
                  ** ({{ programme.qts }}) {{ programme.titre }}.
                </span>

                <hr />
              </div>

              <div class="col-2">
                <div style="margin-top: -4px">
                  <router-link
                    v-if="listes_service[0].man == '1'"
                    :to="{
                      name: 'update_trait_vid',
                      params: { id: programme.id },
                      query: {
                        qtsFix: programme.qts,
                        prixFix: programme.prix,
                      },
                    }"
                  >
                    <img src="mod.png" />
                  </router-link>

                  <router-link
                    v-if="listes_service[0].man == '0'"
                    :to="{
                      name: 'update_trait_vid_okba',
                      params: { id: programme.id },
                    }"
                  >
                    <img src="mod.png" />
                  </router-link>
                  <!-- <img
                    @click="deleteTraitVid(programme.id)"
                    style="margin-left: 22px"
                    src="sup.png"
                  /> -->
                </div>
              </div>
            </CRow>
            <router-link
              :to="{
                name: 'add_trait_vidange_man',
                params: { id: kilo.id },
              }"
            >
              <img src="https://img.icons8.com/ios/50/000000/add--v1.png" />
            </router-link>
          </CCardBody>
        </CCard>
      </div>
      <div v-else>
        <div class="errPage-container">
          <el-row>
            <el-col :span="12">
              <p style="margin-left: 2px" class="text-jumbo">
                Oops! aucun resultat ...
              </p>

              <CButton
                @click="$router.go(-1)"
                style="
                  margin-bottom: 7px;
                  border-radius: 15px 18px;
                  margin-top: 1px;
                  margin-left: 4px;
                  padding: 10px;
                "
                color="danger"
                class="mr-1 cl"
              >
                Retour
              </CButton>

              <router-link to="/">
                <CButton
                  style="
                    margin-bottom: 7px;
                    border-radius: 15px 18px;
                    margin-top: 1px;
                    margin-left: 4px;
                    padding: 10px;
                  "
                  color="info"
                  class="mr-1 cl"
                >
                  Accueil
                </CButton>
              </router-link>
            </el-col>
            <el-col style="margin-top: 19px; margin-left: -13px">
              <img
                src="../../assets/401_images/401.gif"
                width="355"
                height="450"
                alt="Girl has dropped her ice cream."
              />
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <!-- ........................ -->
  </div>
</template>


<script>
import { apiDomain } from "../../config";
import axios from "axios";

export default {
  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  components: {},
  data() {
    return {
      boolean: true,
      listes_service: {},
      service_id: this.$route.params.id,
    };
  },

  created() {
    this.fetchListesTypes(this.$route.params.id);
  },

  computed: {
    all_service() {
      let arr1 = this.listes_service.Kilometrage;

      let arr2 = this.listes_service.Kilometrage;

      let arr3 = arr1.map((item, i) => Object.assign({}, item, arr2[i]));

      console.log(arr3);
      return arr3;
    },

    calculPrix() {
      const listes_service = this.listes_service[0].programmes;

      var result = [];
      var somme = null;

      var prix = 0;

      for (var i = 0; i < listes_service.length; i++) {
        prix += listes_service[i].prix;
      }

      /*    somme += prix;
        result.push(somme); */

      return prix;
    },
  },

  methods: {
    delete_vidange(id) {
      if (confirm("Es-tu sûr??")) {
        fetch(`${apiDomain}/api/delete_vid/${id}`, {
          method: "delete",
        })
          .then((res) => res.json())
          .then((data) => {
            this.$noty.success("Vidange  supprimer avec Succès ! ");
            window.location.reload();
          })

          .catch((err) => console.log(err));
      }
    },
    deleteKilometrageService(id) {
      if (confirm("Es-tu sûr??")) {
        fetch(`${apiDomain}/api/deleteKilomertarge_vidange/${id}`, {
          method: "delete",
        })
          .then((res) => res.json())
          .then((data) => {
            this.$noty.success("vidange  supprimer avec Succès ! ");
            this.fetchListesTypes(this.$route.params.id);
          })

          .catch((err) => console.log(err));
      }
    },
    deleteTraitVid(id) {
      if (confirm("Es-tu sûr??")) {
        fetch(`${apiDomain}/api/deleteTraitVidange/${id}`, {
          method: "delete",
        })
          .then((res) => res.json())
          .then((data) => {
            this.$noty.success("Service  supprimer avec Succès ! ");
            this.fetchListesTypes(this.$route.params.id);
          })

          .catch((err) => console.log(err));
      }
    },

    delete_service(id) {
      if (confirm("Es-tu sûr??")) {
        fetch(`${apiDomain}/api/delete_service/${id}`, {
          method: "delete",
        })
          .then((res) => res.json())
          .then((data) => {
            this.$noty.success("Service  supprimer avec Succès ! ");

            this.fetchListesTypes();
          })

          .catch((err) => console.log(err));
      }
    },
    fetchListesTypes(id) {
      fetch(
        `${apiDomain}/api/Listes_vidange_ajouter_id/${this.$route.params.id}`
      )
        .then((res) => res.json())
        .then((res) => {
          this.listes_service = res.all_service;
        })
        .catch((err) => console.log(err));
    },

    create(e) {
      let formData = new FormData();
      formData.append("service_id", this.$route.params.id);
      formData.append("date", this.listes_service[0].date);

      axios
        .post(`${apiDomain}/api/ajouter_facture`, formData)

        .then((res) => {
          this.$noty.success("Facture Ajouter avec Succès ! ");

          // this.$router.push("/listes_acts");

          // this.fetchsearch();
        })
        .catch((error) => {
          if (error.response && error.response.status == 400) {
            this.validationErrors = error.response.data;
          }
        });
    },
  },
};
</script>

<style>
.non_paye_f {
  position: absolute;
  background: #f10735;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;

  margin-left: -11.4%;
  margin-top: -2.6% !important;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}

.paye_f {
  position: absolute;
  background: #28e40c;

  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -11.4%;

  margin-top: -2.6% !important;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}

.en_attente_f {
  position: absolute;
  background: #c37600;

  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -11.4%;

  margin-top: -2.6% !important;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}
.kit {
  position: absolute;
  background: #e80db9;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  margin-top: 1.4% !important;
  height: 27px;
  line-height: 30px;
  border-radius: 6px;
}
.vidange {
  position: absolute;
  background: #083ce4;

  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  margin-top: 1.4% !important;
  height: 27px;
  line-height: 30px;
  border-radius: 6px;
}

.feed {
  background: #fff;
  height: 106px;
  overflow: scroll;
}
.btdelete {
  padding: 11px 27px !important;
  margin-top: 38px;
  border-radius: 5px;
}
/* 
.md-card img {
  width: 55% !important;
  height: auto;
} */
</style>


<style lang="scss" scoped>
.md-switch {
  display: flex;
}

.md-switch.md-disabled .md-switch-thumb {
  background-color: #ff5252 !important;
  background-color: var(--md-theme-default-switchvariant, #ff5252 !important);
}
</style>

